/* eslint-disable */
import '../../vendor/redactor.js'

var redactorConfig = {
	instances: [],

	init: function (options) {
		if (options) {
			window.redactorFieldPush = options.redactorFieldPush
			this.allFieldsPushedCallback = options.allFieldsPushedCallback
		}

		this.getUIElements()
		this.setup()
	},

	getUIElements: function () {
		this.redactorElements = document.querySelectorAll('.redactor-content')
	},

	setup: function () {
		for (var i = this.redactorElements.length - 1; i >= 0; i--) {
			var editorSettings = JSON.parse(this.redactorElements[i].getAttribute('data-config'))

			var config = {}
			// loop over the options and add them to the config
			if (!config['buttons']) config['buttons'] = []

			if (editorSettings) {
				for (var e = 0; e < editorSettings.length; e++) {

					switch (editorSettings[e]) {
					case 'bold':
						config['buttons'].push('bold')
						break
					case 'formatting':
						config['buttons'].push('format')
						break
					case 'html':
						config['buttons'].push('html')
						break
					case 'image':
						config['buttons'].push('image')
						break
					case 'italic':
						config['buttons'].push('italic')
						break
					case 'link':
						config['buttons'].push('link')
						break
					case 'lists':
						config['buttons'].push('lists')
						break
					case 'underline':
						config['buttons'].push('underline')
						break
					case 'video':
						config['buttons'].push('video')
						break
					}
				}
			}
			
			// Only define this for TriFinance websites
			if (window.location.hostname.indexOf('trifinance') > -1 || window.location.hostname.indexOf('trihd') > -1) {
				config['formatting'] = ["p", "h3", "blockquote"]
			}

			config['minHeight'] = '90px'
			//config['air'] = true
			config['callbacks'] = {}
			config['callbacks']['started'] = this.started	

			Redactor(this.redactorElements[i], config)
			this.instances.push(this.redactorElements[i])

			if (i === 0) {
				if (this.allFieldsPushedCallback) this.allFieldsPushedCallback()
			}
		}
	},

	started: function () {
		var textarea = this.container.$container.nodes[0].querySelector('textarea')
		textarea.setAttribute('tabindex', '-1')

		var redactorStyle = this.container.$container.nodes[0].querySelector('.redactor-styles')
		if (window.redactorFieldPush) window.redactorFieldPush(redactorStyle)

		// active lang
		var el = document.querySelector('.btn-switch[data-toggle-lang].active')
		if (!el) return
		var activeLang = el.getAttribute('data-toggle-lang')

		if (!this.container.$container.nodes[0].parentNode.classList.contains(activeLang)) {
			redactorStyle.setAttribute('tabindex', '-1')
		}
	},

	destroy: function () {
		window.redactorFieldPush = null
		this.allFieldsPushedCallback = null

		for (var i = this.instances.length - 1; i >= 0; i--) {
			Redactor(this.instances[i], 'destroy')
		}
	}
}

export default redactorConfig
